import { Control, Controller } from 'react-hook-form';
import { User } from '../../../../../types';
import { UserFormData } from '../../add-user-dialog/user-form-page';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import SharedProfileInformationAccordion from '../../../../shared/shared-profile-information-accordion';

interface NotesAccordionProps {
  control: Control<UserFormData>;
  user: User | null;
  disabled: boolean;
}

export default function NotesAccordion({
  control,
  disabled,
  user,
}: NotesAccordionProps) {
  return (
    <SharedProfileInformationAccordion
      title="Notes"
      defaultExpanded={!!user?.notes && user.notes !== ''}
      disabled={disabled}
    >
      <Stack
        gap={1}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ my: 1.5 }}
      >
        <Controller
          name="notes"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              autoComplete="off"
              multiline
              rows={3}
              disabled={disabled}
            />
          )}
        />
      </Stack>
    </SharedProfileInformationAccordion>
  );
}
